import { RowRequestDto } from '@asset-metrix/portal-gateway-client-js';
import { triggerDownloadWithAnchorTag } from '@asset-metrix/portal-ui';

import { getContentDispositionFileName } from '../../utils/contentDisposition';
import { extractErrorMessage } from '../../utils/errorMessage';
import { HttpError } from '../errors';
import { portalGatewayClient } from '../portalGatewayClient';

export const downloadTableRow = async ({
  contentId,
  actionId,
  actionRowIds,
  defaultFileName,
  context,
}: {
  contentId: string;
  actionId: string;
  actionRowIds: string[];
  defaultFileName: string;
  context?: RowRequestDto['context'];
}) => {
  const response = await portalGatewayClient.table.downloadTableRows(
    contentId,
    {
      actionId,
      actionRowIds,
      ...(context != null && { context }),
    }
  );

  if (!response.ok) {
    throw new HttpError(
      extractErrorMessage(
        await response.json(),
        'Error downloading table row data'
      ),
      response
    );
  }

  const contentDisposition = response.headers.get('content-disposition');

  const fileName =
    (contentDisposition && getContentDispositionFileName(contentDisposition)) ??
    defaultFileName;

  const blob = await response.blob();
  const blobUrl = URL.createObjectURL(blob);
  triggerDownloadWithAnchorTag(blobUrl, fileName);
};
